module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content exercise-edit-content"
  }, [_c('div', {
    staticClass: "row exercise-edit-body"
  }, [_vm._m(0), (_vm.error) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v(_vm._s(_vm.error))])])]) : _vm._e(), _c('div', {
    staticClass: "col-md-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Ngày tạo")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "created_at",
      "required": "required",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.createdAt
    }
  })])]), _c('div', {
    staticClass: "col-md-6 lv-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Người tạo")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "created_by",
      "required": "required",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.createdBy
    }
  })])]), _c('div', {
    staticClass: "col-md-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Ngày cập nhật")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "updated_at",
      "required": "required",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.updatedAt
    }
  })])]), _c('div', {
    staticClass: "col-md-6 lv-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Người cập nhật")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "updated_by",
      "required": "required",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.updatedBy
    }
  })])]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "col-md-12 col-md-name"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tên bài tập *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameExercise),
      expression: "nameExercise"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Nhập tên bài tập",
      "required": "required",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.nameExercise)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameExercise = $event.target.value
      }
    }
  })])]), _c('div', {
    staticClass: "col-md-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chọn môn học *")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "subject-id",
      "required": "required"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'subject')
      }
    }
  }, _vm._l((_vm.subjects), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id,
        "selected": o.id === _vm.subjectID
      }
    }, [_vm._v(_vm._s(o.name))])
  }), 0)])]), _c('div', {
    staticClass: "col-md-6 lv-question col-grade-id"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chọn khối lớp *")]), _c('Select2', {
    attrs: {
      "id": "grade_id",
      "options": _vm.grades,
      "settings": _vm.settingGrades
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'grade')
      }
    },
    model: {
      value: (_vm.gradeID),
      callback: function($$v) {
        _vm.gradeID = $$v
      },
      expression: "gradeID"
    }
  })], 1)]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "col-md-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Danh mục bài tập *")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "categ-id",
      "required": "required"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'category')
      }
    }
  }, _vm._l((_vm.categExercise), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id,
        "selected": o.id === _vm.categoryID
      }
    }, [_vm._v(_vm._s(o.name))])
  }), 0)])]), _c('div', {
    staticClass: "col-md-6 lv-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Loại bài tập *")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "type-id",
      "required": "required"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'type-exercise')
      }
    }
  }, _vm._l((_vm.lstTypeTest), function(o) {
    return _c('option', {
      domProps: {
        "value": o.key,
        "selected": o.key === _vm.typeExercise
      }
    }, [_vm._v(_vm._s(o.name))])
  }), 0)])]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "col-md-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cấp độ bài tập *")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "level",
      "required": "required"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'level')
      }
    }
  }, _vm._l((_vm.lstLevel), function(o) {
    return _c('option', {
      domProps: {
        "value": o.key,
        "selected": o.key === _vm.level
      }
    }, [_vm._v(_vm._s(o.value))])
  }), 0)]), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "col-md-12 list-questions"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("DANH SÁCH CÂU HỎI")]), _c('div', {
    staticClass: "card card-question"
  }, [_c('div', {
    staticClass: "card-content card-content-question"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-6 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Danh mục câu hỏi")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "categ-question-id",
      "required": "required"
    },
    on: {
      "change": function($event) {
        return _vm.onFilterQuestion($event, 'category')
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "selected": "selected"
    }
  }, [_vm._v("Chọn danh mục câu hỏi")]), _vm._l((_vm.categQuestion), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(o.name))])
  })], 2)])]), _c('div', {
    staticClass: "col-md-6 col-xs-6 lv-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cấp độ câu hỏi")]), _c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "lv-question",
      "required": "required"
    },
    on: {
      "change": function($event) {
        return _vm.onFilterQuestion($event, 'level')
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "selected": "selected"
    }
  }, [_vm._v("Chọn cấp độ câu hỏi")]), _vm._l((_vm.lstLevel), function(o) {
    return _c('option', {
      domProps: {
        "value": o.key
      }
    }, [_vm._v(_vm._s(o.value))])
  })], 2)])]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "col-md-9 col-xs-7 categ-question"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Chọn câu hỏi *")]), _c('Select2', {
    key: _vm.force,
    attrs: {
      "options": _vm.questions,
      "settings": _vm.settingQuestions
    },
    on: {
      "select": function($event) {
        return _vm.onFilterQuestion($event, 'question')
      }
    }
  })], 1)]), _c('div', {
    staticClass: "col-md-3 col-xs-5 lv-question"
  }, [_c('div', {
    staticClass: "box-btn-question-search"
  }, [_c('button', {
    staticClass: "btn btn-question-search",
    on: {
      "click": _vm.addQuestion
    }
  }, [_vm._v("Thêm câu hỏi")])])])])]), _c('div', {
    staticClass: "line"
  }), _c('div', {
    staticClass: "card-content card-table-question"
  }, [(!_vm.$isMobile()) ? _c('div', {
    staticClass: "box-table-question",
    on: {
      "&scroll": function($event) {
        return _vm.handleScroll($event)
      }
    }
  }, [_c('tbQuestion', {
    key: _vm.force,
    attrs: {
      "keyword": _vm.filtername,
      "lstLevel": _vm.lstLevel,
      "lstFilter": _vm.lstFilter,
      "data": _vm.lstCurrQuestion,
      "offset": _vm.offset,
      "limit": _vm.limit,
      "columns": _vm.columns,
      "config": _vm.config,
      "inlineFilter": true
    },
    on: {
      "onfilterbyname": _vm.filterbyname,
      "onItemDelete": _vm.onQuestionFormDelete,
      "onItemEdit": _vm.onQuestionFormEdit,
      "onItemView": _vm.onQuestionFormView,
      "onFilterBlue": _vm.filterBlue,
      "pageChange": _vm.onPageChange
    }
  })], 1) : _c('div', {
    staticClass: "card-lst-question"
  }, [_c('div', {
    staticClass: "row-header"
  }, [_c('span', {
    staticClass: "label-header"
  }, [_vm._v("Câu hỏi")]), _c('div', {
    staticClass: "field-header"
  }, [_c('input', {
    attrs: {
      "placeholder": "Tìm theo nội dung câu hỏi lớn"
    },
    on: {
      "change": function($event) {
        return _vm.filterbyname($event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "clearfix"
  }), (_vm.lstCurrQuestion.length > 0) ? _c('div', {
    staticClass: "list-item"
  }, _vm._l((_vm.lstCurrQuestion), function(item, index) {
    return _c('div', {
      staticClass: "row-item"
    }, [_c('div', {
      staticClass: "row-data"
    }, [_c('div', {
      staticClass: "board-info"
    }, [_c('span', [_vm._v(_vm._s(item.content_plain_text))])])]), _c('div', {
      staticClass: "row-data"
    }, [_c('div', {
      staticClass: "filter-item"
    }, [_c('span', {
      class: _vm.lstFilter.categories.includes(item.category_question.id) ? 'checked' : '',
      attrs: {
        "id": 'categ_' + item.category_question.id
      },
      on: {
        "click": function($event) {
          return _vm.filterItems(item.category_question.id, 1)
        }
      }
    }, [_vm._v(_vm._s(item.category_question.name))]), _c('span', {
      class: _vm.lstFilter.level.includes(item.level) ? 'checked' : '',
      attrs: {
        "id": 'lv_' + item.level
      },
      on: {
        "click": function($event) {
          return _vm.filterItems(item.level, 2)
        }
      }
    }, [_vm._v(_vm._s(_vm.getDataValue(item.level, 1)))]), _vm._l((item.question_grade), function(g) {
      return _c('span', {
        class: _vm.lstFilter.grades.includes(g.grade.id) ? 'checked' : '',
        attrs: {
          "id": 'grade_' + g.grade.id
        },
        on: {
          "click": function($event) {
            return _vm.filterItems(g.grade.id, 3)
          }
        }
      }, [_vm._v(_vm._s(g.grade.name))])
    })], 2)]), _c('div', {
      staticClass: "row-data"
    }, [_c('div', {
      staticClass: "action-buttons"
    }, [_c('span', {
      staticClass: "list-action"
    }, [_c('small', {
      on: {
        "click": function($event) {
          return _vm.onQuestionFormEdit(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require('../../assets/images/faces/ic_edit.svg')
      }
    })])]), _c('span', {
      staticClass: "list-action"
    }, [_c('small', {
      on: {
        "click": function($event) {
          return _vm.onQuestionFormDelete(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require('../../assets/images/theory/delete-24px.svg')
      }
    })])]), _c('span', {
      staticClass: "list-action"
    }, [_c('small', {
      staticClass: "support"
    }, [_c('div', {
      staticClass: "fas fa-eye",
      staticStyle: {
        "color": "#333333",
        "margin-top": "9px"
      },
      on: {
        "click": function($event) {
          return _vm.onQuestionFormView(item)
        }
      }
    })])])])])])
  }), 0) : _vm._e(), _c('div', {
    staticClass: "clearfix"
  }), (_vm.lstCurrQuestion.length > 0) ? _c('Pagination', {
    attrs: {
      "screenExercise": true,
      "currentPage": _vm.config.currentPage,
      "pageRange": _vm.config.pageRange,
      "itemsPerPage": _vm.config.itemsPerPage,
      "totalItems": _vm.config.totalItems
    },
    on: {
      "pageChange": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "col-md-6 total-time"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tổng thời gian làm bài tập (phút) *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.time),
      expression: "time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "time",
      "type": "number",
      "min": "0",
      "placeholder": "Nhập"
    },
    domProps: {
      "value": (_vm.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.time = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "clearfix"
  })]), _c('div', {
    staticClass: "col-md-12 col-checkbox"
  }, [_c('div', {
    staticClass: "box-save"
  }, [_c('div', {
    staticClass: "title box-item-footer",
    style: (_vm.$isMobile() ? 'top: 0' : '')
  }, [_vm._v("LƯU BÀI TẬP")]), (_vm.$isMobile()) ? _c('div', {
    staticClass: "clearfix"
  }) : _vm._e(), _c('div', {
    staticClass: "box-item-footer"
  }, [_c('div', {
    staticClass: "item-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "cb_question",
      "id": "cb_question"
    },
    domProps: {
      "checked": _vm.is_save_edit
    },
    on: {
      "click": function($event) {
        return _vm.onCheckSave($event, 3)
      }
    }
  }), _c('label', {
    attrs: {
      "for": "cb_question"
    }
  }), _c('span', [_vm._v("Lưu lại và chỉnh sửa sau")])])]), _c('div', {
    staticClass: "card card-save"
  }, [_c('div', {
    staticClass: "card-content card-content-save"
  }, [_c('div', {
    class: _vm.is_save_edit ? 'opacity' : ''
  }), _c('div', {
    staticClass: "item-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "public_all",
      "id": "public_all"
    },
    domProps: {
      "checked": _vm.default_public
    },
    on: {
      "click": function($event) {
        return _vm.onCheckSave($event, 1)
      }
    }
  }), _c('label', {
    attrs: {
      "for": "public_all"
    }
  }), _c('span', [_vm._v("Lưu bài tập và cho phép học sinh trong toàn hệ thống tìm kiếm được để mua đáp án")])]), _c('div', {
    staticClass: "clearfix"
  }), _c('div', {
    staticClass: "item-checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "public_pc",
      "id": "public_pc"
    },
    domProps: {
      "checked": _vm.default_public_pc
    },
    on: {
      "click": function($event) {
        return _vm.onCheckSave($event, 2)
      }
    }
  }), _c('label', {
    attrs: {
      "for": "public_pc"
    }
  }), _c('span', [_vm._v("Lưu bài tập riêng tư (chỉ cho hiển thị trong cộng đồng và lớp học của tôi)")])]), (_vm.is_public_pc > 1) ? _c('div', {
    staticClass: "box-left"
  }, [_c('div', {
    staticClass: "row row-amount-honey"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Số hũ mật ong để xem đáp án *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amountHoney),
      expression: "amountHoney"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "amount_honey",
      "type": "text",
      "placeholder": "Nhập số hũ mật ong",
      "required": "required"
    },
    domProps: {
      "value": (_vm.amountHoney)
    },
    on: {
      "keypress": _vm.checkNumber,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amountHoney = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "row row-share-class"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "id": "class_id",
      "required": "required"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeSelect($event, 'class')
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0",
      "selected": "selected",
      "disabled": "disabled"
    }
  }, [_vm._v("Chọn lớp học bạn muốn chia sẻ trong PC")]), _vm._l((_vm.classes), function(o) {
    return _c('option', {
      attrs: {
        "data-exercises": o.exercise_ids
      },
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(o.name))])
  })], 2)])])]), _c('div', {
    staticClass: "row row-class"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, _vm._l((_vm.lstClassAdded), function(item, index) {
    return (item) ? _c('div', {
      staticClass: "box-item-attach"
    }, [_c('label', [_c('img', {
      attrs: {
        "src": require("../../assets/images/theory/ic_class.png")
      }
    }), _c('span', [_vm._v(_vm._s(item.name))]), _c('span', {
      staticClass: "material-icons remove",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.deleteClass(index)
        }
      }
    }, [_vm._v("delete")])])]) : _vm._e()
  }), 0)])]) : _vm._e()])])]), _c('div', {
    staticClass: "button-handle"
  }, [_c('button', {
    staticClass: "btn btn-active",
    on: {
      "click": function($event) {
        return _vm.validateSave(1)
      }
    }
  }, [_vm._v("Lưu thay đổi")]), _c('button', {
    staticClass: "btn btn-rest",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        return _vm.validateSave(2)
      }
    }
  }, [_vm._v("Huỷ yêu cầu")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-md-header"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Chỉnh sửa bài tập")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03dbcd03","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Exercise/edit.vue
// module id = 1472
// module chunks = 0